<div class="snackCookies">
  <span class="snack">This website uses cookies to provide you with a great user experience. By using EDClin, you accept
    <a routerLink="/privacy-policy" class="snackbar-link" (click)="close()">
      our use of cookies</a>.
  </span>
  
  <button mat-button (click)="snackBarRef.dismiss()" class="snackbtn">
    <span class="a404">Got it</span>
  </button>

</div>